module.exports = __webpack_public_path__ + "img/hr-deepwater-inner-corner.981af136.png";